import React from "react";
import { formatNumber, formatCurrency } from "@wrstudios/utils";
import Link from "../link";
import { Container, Grid, Price, Address, Location, Status, Details, Date, Icon } from "./styled/listing-card-data";
function ListingCardData(_a) {
    var url = _a.url, isHidden = _a.isHidden, address = _a.address, city = _a.city, state = _a.state, zip = _a.zip, built = _a.built, statusLabel = _a.statusLabel, statusValue = _a.statusValue, acresFormatted = _a.acresFormatted, priceFormatted = _a.priceFormatted, bedsFormatted = _a.bedsFormatted, bathsFormatted = _a.bathsFormatted, sqftFormatted = _a.sqftFormatted, updatedAtAgo = _a.updatedAtAgo, oldPrice = _a.oldPrice, newPrice = _a.newPrice, handleClick = _a.handleClick;
    var location = [city, state, zip].filter(Boolean).join(", ");
    var details = [bedsFormatted, bathsFormatted, sqftFormatted, built].filter(Boolean);
    var hasDetails = !!details.length;
    var detailsList = details.map(function (detail, index) { return (React.createElement("span", { key: index },
        index > 0 ? React.createElement(React.Fragment, null, " \u2022 ") : null,
        detail)); });
    var container = (React.createElement(Container, { isHidden: isHidden },
        [address, priceFormatted].some(Boolean) && (React.createElement(Grid, null,
            React.createElement(Address, { title: address }, address),
            React.createElement(Price, null, priceFormatted))),
        [location, statusLabel, statusValue].some(Boolean) && (React.createElement(Grid, null,
            React.createElement(Location, { title: location }, location),
            React.createElement(Status, { title: statusLabel, statusValue: statusValue },
                !!oldPrice && !!newPrice && (React.createElement(React.Fragment, null,
                    newPrice < oldPrice ? (React.createElement(Icon, null, "\u2193")) : (React.createElement(Icon, null, "\u2191")),
                    formatCurrency(Math.abs(Number(formatNumber(oldPrice, "0")) -
                        Number(formatNumber(newPrice, "0")))))),
                (!oldPrice || !newPrice) && statusLabel))),
        [hasDetails, updatedAtAgo].some(Boolean) && (React.createElement(Grid, null,
            hasDetails && (React.createElement(Details, { title: details.join(", ") }, detailsList)),
            !hasDetails && (React.createElement(Details, { title: acresFormatted }, acresFormatted)),
            React.createElement(Date, { title: updatedAtAgo }, updatedAtAgo)))));
    if (url)
        return React.createElement(Link, { to: url }, container);
    return React.createElement("div", { onClick: handleClick }, container);
}
export default ListingCardData;
